<template>
  <div>
    <input
      type="number"
      :class="'form-control ' + input.class"
      :value="value"
      @change="(e) => handleChange(e)"
      :placeholder="input.placeholder"
      :required="!input.optional"
      :disabled="input.disabled"
      :name="input.name"
      :id="input.id ? input.id : input.name"
    />
  </div>
</template>
<script>
export default {
  name: "InputNumber",
  components: {},
  props: {
    input: Object,
    value: [Number, String],
  },
  data: function() {
    return {};
  },
  methods: {
    handleChange(e) {
      this.$emit("handleChange", e);
    },
  },
};
</script>
